import React from "react";
import { Script } from "gatsby";

const MagicBlocksChat = () => {
  return (
      <Script id="magicblocks-chatbot-script" type="text/javascript">
        {`window.MAGICBLOCKS = {
          workspace: 'ws_6GhNSVOkW4mmfqC',
          experience: '${process.env.GATSBY_MAGICBLOCK_EXPERIENCE_ID}',
          config: {
            style: 'dynamic',
            ${process.env.GATSBY_MAGICBLOCK_TEST_MODE === 'true' ? "mode: 'test'" : ''}
          }
        };
        (function () {
          var queryPath = '?ws=' + window.MAGICBLOCKS.workspace + '&e=' + window.MAGICBLOCKS.experience;
          var h = document.getElementsByTagName('body')[0];
          var s = document.createElement('script');
          s.id = 'mbw-script';
          s.type = 'text/javascript';
          s.src = 'https://scripts.magicblocks.com/widget/1.0.0' + queryPath;
          h.appendChild(s);
        })();`}
      </Script>
  );
};

export default MagicBlocksChat;